import {
  Dependent,
  IFittingPreviewData,
  IPurchasesData,
} from '../../../../../../../graphql/lenses/models/get-lenses-preview.models';
import {
  LensesBrandType,
  SolutionsBrandType,
} from '../../../../../../../graphql/lenses/models/get-lenses.models';

const findBrandType = (
  brands: (LensesBrandType | SolutionsBrandType)[], type: LensesBrandType,
): LensesBrandType | SolutionsBrandType | undefined => {
  return brands.find((brand) => brand === type);
};

const findPriorityBrand = (brands: (
  LensesBrandType | SolutionsBrandType)[],
): LensesBrandType | SolutionsBrandType | undefined | null  => {
  return brands.length
    ? (
      findBrandType(brands, LensesBrandType.aom1d)
      || findBrandType(brands, LensesBrandType.aomax1dmffa)
      || findBrandType(brands, LensesBrandType.aomaxmf)
      || findBrandType(brands, LensesBrandType.aomax1dfa)
      || findBrandType(brands, LensesBrandType.aoh1dfa)
      || findBrandType(brands, LensesBrandType.oneDamfa)
      || findBrandType(brands, LensesBrandType.oneDamm)
      || findBrandType(brands, LensesBrandType.oneDadf)
      || findBrandType(brands, LensesBrandType.aoh1d)
      || findBrandType(brands, LensesBrandType.oneDam)
      || findBrandType(brands, LensesBrandType.oneDate)
      || findBrandType(brands, LensesBrandType.aohfa)
      || findBrandType(brands, LensesBrandType.aohm)
      || findBrandType(brands, LensesBrandType.aowt)
      || findBrandType(brands, LensesBrandType.aoh)
      || findBrandType(brands, LensesBrandType.aa1d)
    ) : null;
};

export const getBrandByPriority = (
  data: IPurchasesData | IFittingPreviewData | Dependent | undefined,
) => {
  let brands: (LensesBrandType | SolutionsBrandType)[] = [];
  // TODO Refactor return null
  if (!data) {
    return null;
  }

  if ('scannedProduct' in data) {
    brands = data.scannedProduct.map(({ myAcuvueBrandCode }) => myAcuvueBrandCode);
  } else if ('dependentFittings' in data && Array.isArray(data.dependentFittings)) {
    brands = data.dependentFittings.flatMap((fitting) =>
      fitting.fittedBrands?.map(({ product }) => product) || [],
    );
  } else if ('fittedBrands' in data) {
    brands = data.fittedBrands?.map(({ brand }) => brand?.product) || [];
  } else {
    return null;
  }

  return findPriorityBrand(brands);
};
